import { YouthMeResponse } from "../authEndpoints/type";
import { baseApi } from "../baseApi";
import {
  ChangePasswordRequest,
  ChangePasswordResponse,
  DeleteProfileImageOrBannerResponse,
  GetCounselorListResponse,
  GetUserByIdResponse,
  UpdateProfileImageOrBannerResponse,
  UpdateUserInfoRequest,
  UpdateUserInfoResponse,
} from "./type";

export const userProfileApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    changePassword: build.mutation<
      ChangePasswordResponse,
      ChangePasswordRequest
    >({
      query: (body) => ({
        url: "/auth/change-password",
        method: "POST",
        body,
      }),
    }),
    getMe: build.query<YouthMeResponse, void>({
      query: () => ({
        url: "/youth/me",
        method: "GET",
        cache: "no-store",
      }),
      providesTags: ["Me"],
    }),
    updateUserInfo: build.mutation<
      UpdateUserInfoResponse,
      UpdateUserInfoRequest
    >({
      query: (body) => ({
        url: "/youth/update-info",
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Me"],
    }),
    getUserById: build.query<GetUserByIdResponse, { userId: string }>({
      query: ({ userId }) => `/user-info/${userId}`,
    }),
    getCounselorList: build.query<GetCounselorListResponse, void>({
      query: () => ({
        url: `/youth/school-district/counsellors`,
        method: "GET",
      }),
    }),
    updateProfileImage: build.mutation<
      UpdateProfileImageOrBannerResponse,
      { id: string; body: FormData }
    >({
      query: (data) => ({
        url: `user-info/${data.id}/profile-image`,
        method: "POST",
        body: data.body,
      }),
      invalidatesTags: ["Me"],
    }),
    addCounsellor: build.mutation<
      { message: string },
      { counsellorId: string }
    >({
      query: (data) => ({
        url: `/youth/counsellor/add`,
        method: "POST",
        body: { counsellorId: data.counsellorId },
      }),
    }),
    deleteProfileImage: build.mutation<
      DeleteProfileImageOrBannerResponse,
      { id: string }
    >({
      query: (data) => ({
        url: `user-info/${data.id}/profile-image`,
        method: "DELETE",
      }),
      invalidatesTags: ["Me"],
    }),
    updateCoverImage: build.mutation<
      UpdateProfileImageOrBannerResponse,
      { id: string; body: FormData }
    >({
      query: (data) => ({
        url: `user-info/${data.id}/cover-image`,
        method: "POST",
        body: data.body,
      }),
      invalidatesTags: ["Me"],
    }),
    deleteCoverImage: build.mutation<
      DeleteProfileImageOrBannerResponse,
      { id: string }
    >({
      query: (data) => ({
        url: `user-info/${data.id}/cover-image`,
        method: "DELETE",
      }),
      invalidatesTags: ["Me"],
    }),
    verifyEmailUpdate: build.mutation<
      { message: string },
      { confirmationCode: string }
    >({
      query: (body) => ({
        url: "/auth/verify-email-update",
        method: "POST",
        body,
      }),
        invalidatesTags: ["Me"],
    }),
  }),
});

export const {
  useGetMeQuery,
  useUpdateCoverImageMutation,
  useDeleteCoverImageMutation,
  useUpdateProfileImageMutation,
  useDeleteProfileImageMutation,
  useChangePasswordMutation,
  useUpdateUserInfoMutation,
  useGetUserByIdQuery,
  useGetCounselorListQuery,
  useAddCounsellorMutation,
  useVerifyEmailUpdateMutation,
} = userProfileApi;
